import { IPathBoxData } from '@leafer-ui/interface'
import { BoxData } from '@leafer-ui/draw'


export class PathBoxData extends BoxData implements IPathBoxData {

}
